import { create } from "zustand";
import type { User } from "@/types/api";

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setAuth: (user: User | null, token: string | null) => void;
  setToken: (token: string | null) => void;
  clear: () => void;
}

// Token lives in memory only — never persisted. Reload = silent refresh.
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  setAuth: (user, token) => set({ user, accessToken: token }),
  setToken: (token) => set({ accessToken: token }),
  clear: () => set({ user: null, accessToken: null }),
}));
